import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getTrainList() {
    return httpAdminClient.get('admin/train/activities?page=1&per_page=10000');
  },
  createTrain(data) {
    return httpAdminClient.post('admin/train/activities', { train_activity: { ...data } });
  },
  patchTrain(id, data) {
    return httpAdminClient.patch(`admin/train/activities/${id}`, { train_activity: { ...data } });
  },
  deleteTrain(id) {
    return httpAdminClient.delete(`admin/train/activities/${id}`);
  },
  showTrain(id) {
    return httpAdminClient.get(`admin/train/activities/${id}`);
  },

  showTrainApplys(activityId, page, perpage, state) {
    return httpAdminClient.get(`/admin/train/activities/${activityId}/entries?page=${page}&per_page=${perpage}&state=${state}`);
  },
  showUserWork(id) {
    return httpAdminClient.get(`/admin/train/entries/${id}/homeworks?page=1&per_page=10000'`);
  },
  showUserLog(trainId, userId) {
    return httpAdminClient.get(`/admin/train/activities/${trainId}/logs?user_id=${userId}&page=1&per_page=10000'`);
  },
  patchEntry(entryId, data) {
    return httpAdminClient.put(`/admin/train/entries/${entryId}`, { train_entry: { ...data } });
  },
  passEntry(id) {
    return httpAdminClient.post(`/admin/train/entries/${id}/apply`);
  },
  noPassEntry(id) {
    return httpAdminClient.post(`/admin/train/entries/${id}/cancel`);
  },
  export(id) {
    return httpAdminClient.get(`admin/train/activities/${id}/export`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/train/trainApi.js